import styled, { keyframes } from "styled-components";
import tw from "twin.macro";
import GradientButton from "../../../../components/GradientButton";

const SectionNine = styled.section`
  ${tw`relative`}
  z-index: 1;
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    min-height: 70vh;
  }
`;

const SectionNineTop = styled.div`
  background: #fff;
  flex: 0 0 38vh;
  display: flex;
  align-items: center;

  @media (max-width: 1023px) {
    flex: initial;
  }
`;

const SectionNineTopInner = styled.div`
  ${tw`mx-auto`}
  width: 100%;
  max-width: 1440px;
  padding: 3rem var(--app-content-gutter) 2.5rem;
`;

const SectionNineTitle = styled.h3`
  margin: 0;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  line-height: 1.1;
  font-weight: 700;
  color: #1e1e1e;
  text-transform: uppercase;
`;

const SectionNineLogoItem = styled.div`
  flex: 0 0 auto;
  min-width: clamp(118px, 16vw, 176px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SectionNineLogo = styled.img`
  width: 100%;
  max-width: 210px;
  width: auto;
  max-width: 100%;
  max-height: 52px;
  height: auto;
  object-fit: contain;
  display: block;
`;

const SectionNineBottom = styled.div`
  position: relative;
  overflow: hidden;
  flex: 1 1 auto;
  background: url("/novas-imagens/section-eight/background.png") center/cover
    no-repeat;

  @media (max-width: 767px) {
    min-height: clamp(650px, 70vh, 720px);
    background: url("/novas-imagens/section-eight/background-mobile.png") 80%
      center / auto 100% no-repeat;

    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
  }
`;

const SectionNineBottomInner = styled.div`
  ${tw`mx-auto grid gap-10`}
  max-width: 1440px;
  min-height: 100%;
  padding: 2.7rem var(--app-content-gutter) 2.8rem;

  @media (min-width: 1024px) {
    grid-template-columns: 1.05fr 0.55fr 1.1fr;
    column-gap: 1rem;
    align-items: start;
  }

  @media (max-width: 767px) {
    display: block;
    padding: 1.65rem 30px 2.3rem;

    height: 100%;
    width: 100%;
  }
`;

const SectionNineResults = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    min-height: 100%;
  }

  @media (max-width: 767px) {
    min-height: 0;
    align-items: flex-start;
  }
`;

const SectionNineResultsTitle = styled.h3`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.15;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;

  @media (max-width: 767px) {
    margin-top: 1.55rem;
    font-size: 20px;
    line-height: 1.12;
  }
`;

const StarsRow = styled.div`
  margin-top: 0.9rem;
  width: 154px;
  height: 36px;

  @media (max-width: 767px) {
    margin-top: 0.7rem;
  }
`;

const StarsImage = styled.img`
  width: 320px;
  max-width: 100%;
  height: auto;
  display: block;
`;

const SectionNineActions = styled.div`
  ${tw`flex flex-col gap-4`}
  margin-top: 2rem;
  flex-direction: row;

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 767px) {
    width: min(100%, 330px);
    margin: 2.05rem auto 0;
    flex-direction: column;
    gap: 1rem;
  }
`;

const SectionNineCta = styled(GradientButton).attrs(({ to }) => ({
  as: to ? undefined : "button",
  $variant: "teal",
}))`
  min-width: 250px;
  max-width: 100%;
  padding: 12px 28px;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 1.1;
  font-weight: 500;

  @media (max-width: 767px) {
    width: 100%;
    min-width: 0;
    height: 40px;
    padding: 12px 24px;
  }
`;

const SectionNineBrand = styled.img`
  width: 180px;
  max-width: 100%;
  height: auto;
  display: block;
  margin-top: auto;
  padding-top: 3rem;
  object-fit: contain;

  @media (max-width: 767px) {
    order: -1;
    width: 150px;
    margin-top: 0;
    padding-top: 0;
  }
`;

const SectionNineLegal = styled.div`
  margin-top: 1rem;

  @media (max-width: 767px) {
    margin-top: 1.25rem;
  }
`;

const SectionNineLegalButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.82);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;

  &:hover {
    color: #fff;
  }
`;

const FapescLogo = styled.img`
  display: block;
  width: 180px;
  max-width: 100%;
  height: auto;
  margin-top: 1.65rem;
  margin-left: -22px;
  object-fit: contain;

  @media (max-width: 767px) {
    width: 150px;
    margin-top: 1.35rem;
    margin-left: -18px;
  }
`;

const SectionNineSocial = styled.div`
  color: #fff;
  text-align: center;

  @media (min-width: 1024px) {
    padding-top: 0.2rem;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SectionNineSocialTitle = styled.h4`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.1;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
`;

const SocialStack = styled.div`
  ${tw`flex flex-col items-center gap-4`}
  margin-top: 1.5rem;

  @media (max-width: 767px) {
    flex-direction: row;
    justify-content: flex-start;
    gap: 1.2rem;
    margin-top: 1rem;
  }
`;

const SocialIconLink = styled.a`
  ${tw`inline-flex items-center justify-center`}
`;

const SocialIconImage = styled.img`
  width: 50px;
  height: 50px;
  display: block;

  @media (max-width: 767px) {
    width: 42px;
    height: 42px;
  }
`;

const SocialIconImageYoutube = styled.img`
  width: 50px;
  height: 36px;
  display: block;
`;

const SectionNineMobileSocial = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
    margin-top: 1.55rem;
    color: #fff;
    text-align: left;
  }
`;

const LogoCarouselTrack = keyframes`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(-50%, 0, 0);
  }
`;

const SectionNineLogos = styled.div`
  ${tw`grid gap-8 items-center justify-items-center`}
  overflow: hidden;
  margin: 3rem 0 0;
`;

const SectionNineLogosTrack = styled.div`
  --logo-gap: clamp(1.75rem, 4vw, 3.5rem);

  display: flex;
  align-items: center;
  width: max-content;
  animation: ${LogoCarouselTrack} 30s linear infinite;
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const SectionNineLogosGroup = styled.div`
  display: flex;
  align-items: center;
  gap: var(--logo-gap);
  flex: 0 0 auto;
  padding-right: var(--logo-gap);
`;

export {
  SectionNine,
  SectionNineTop,
  SectionNineTopInner,
  SectionNineTitle,
  SectionNineLogos,
  SectionNineLogo,
  SectionNineBottom,
  SectionNineBottomInner,
  SectionNineResults,
  SectionNineResultsTitle,
  StarsRow,
  StarsImage,
  SectionNineActions,
  SectionNineCta,
  SectionNineBrand,
  SectionNineLegal,
  SectionNineLegalButton,
  FapescLogo,
  SectionNineSocial,
  SectionNineMobileSocial,
  SectionNineSocialTitle,
  SocialStack,
  SocialIconLink,
  SocialIconImage,
  SocialIconImageYoutube,
  LogoCarouselTrack,
  SectionNineLogosTrack,
  SectionNineLogosGroup,
  SectionNineLogoItem,
};
